import { render, staticRenderFns } from "./CertSaveTJ.vue?vue&type=template&id=5636059b&scoped=true&"
import script from "./CertSaveTJ.vue?vue&type=script&lang=js&"
export * from "./CertSaveTJ.vue?vue&type=script&lang=js&"
import style0 from "./CertSaveTJ.vue?vue&type=style&index=0&id=5636059b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5636059b",
  null
  
)

export default component.exports